import { DEFlagIcon } from '@/shared/assets/icons/flags/de-flag-icon';
import { ESFlagIcon } from '@/shared/assets/icons/flags/es-flag-icon';
import { FIFlagIcon } from '@/shared/assets/icons/flags/fi-flag-icon';
import { FRFlagIcon } from '@/shared/assets/icons/flags/fr-flag-icon';
import { HUFlagIcon } from '@/shared/assets/icons/flags/hu-flag-icon';
import { ITFlagIcon } from '@/shared/assets/icons/flags/it-flag-icon';
import { JAFlagIcon } from '@/shared/assets/icons/flags/ja-flag-icon';
import { KOFlagIcon } from '@/shared/assets/icons/flags/ko-flag-icon';
import { NLFlagIcon } from '@/shared/assets/icons/flags/nl-flag-icon';
import { PLFlagIcon } from '@/shared/assets/icons/flags/pl-flag-icon';
import { PTFlagIcon } from '@/shared/assets/icons/flags/pt-flag-icon';
import { SKFlagIcon } from '@/shared/assets/icons/flags/sk-flag-icon';
import { SVFlagIcon } from '@/shared/assets/icons/flags/sv-flag-icon';
import { USFlagIcon } from '@/shared/assets/icons/flags/us-flag-icon';
import {
  TLanguageOption,
  UiLanguageEnum,
} from '@/shared/features/language-switcher/language-switcher.types';

const languageSortCollator = new Intl.Collator('en', { sensitivity: 'base' });

export const LANGUAGE_OPTIONS: TLanguageOption[] = [
  {
    code: UiLanguageEnum.ENGLISH,
    flag: <USFlagIcon />,
    sortLabel: 'English',
  },
  {
    code: UiLanguageEnum.GERMAN,
    flag: <DEFlagIcon />,
    sortLabel: 'Deutsch',
  },
  {
    code: UiLanguageEnum.SPANISH,
    flag: <ESFlagIcon />,
    sortLabel: 'Español',
  },
  {
    code: UiLanguageEnum.PORTUGUESE,
    flag: <PTFlagIcon />,
    sortLabel: 'Português',
  },
  {
    code: UiLanguageEnum.ITALIAN,
    flag: <ITFlagIcon />,
    sortLabel: 'Italiano',
  },
  {
    code: UiLanguageEnum.FRENCH,
    flag: <FRFlagIcon />,
    sortLabel: 'Français',
  },
  {
    code: UiLanguageEnum.JAPANESE,
    flag: <JAFlagIcon />,
    sortLabel: '日本語',
  },
  {
    code: UiLanguageEnum.KOREAN,
    flag: <KOFlagIcon />,
    sortLabel: '한국어',
  },
  {
    code: UiLanguageEnum.DUTCH,
    flag: <NLFlagIcon />,
    sortLabel: 'Nederlands',
  },
  {
    code: UiLanguageEnum.FINNISH,
    flag: <FIFlagIcon />,
    sortLabel: 'Suomi',
  },
  {
    code: UiLanguageEnum.HUNGARIAN,
    flag: <HUFlagIcon />,
    sortLabel: 'Magyar',
  },
  {
    code: UiLanguageEnum.POLISH,
    flag: <PLFlagIcon />,
    sortLabel: 'Polski',
  },
  {
    code: UiLanguageEnum.SLOVAK,
    flag: <SKFlagIcon />,
    sortLabel: 'Slovenčina',
  },
  {
    code: UiLanguageEnum.SWEDISH,
    flag: <SVFlagIcon />,
    sortLabel: 'Svenska',
  },
].sort((left, right) =>
  languageSortCollator.compare(left.sortLabel, right.sortLabel),
);
